import { stringToUtcDate } from 'src/utils/dateTimeUtils';
import { ReachProSupportCaseResponse } from 'src/WebApiController';

export interface SupportCasePage {
  items: ReachProSupportCaseResponse[];
  hasMore: boolean;
}

export function getSupportCaseTimestampMs(
  c: ReachProSupportCaseResponse
): number {
  return c.lastMessageTimestamp
    ? stringToUtcDate(c.lastMessageTimestamp).getTime()
    : stringToUtcDate(c.createDate).getTime();
}

export function flattenSupportCasePages(
  pages: (SupportCasePage | null | undefined)[]
): ReachProSupportCaseResponse[] {
  const byId = new Map<number, ReachProSupportCaseResponse>();
  for (const page of pages) {
    for (const c of page?.items ?? []) {
      if (!byId.has(c.workItemId)) {
        byId.set(c.workItemId, c);
      }
    }
  }
  return [...byId.values()].sort(
    (a, b) => getSupportCaseTimestampMs(b) - getSupportCaseTimestampMs(a)
  );
}
